import React, { useEffect, useState } from 'react';
import axios from 'axios';
import NumberAnimated from './NumberAnimated';

const Consolidated = () => {
  const API_URL = 'https://accessi.sgsmails.com/api.php';
  const tables = ['hendrick', 'rimon', 'bridged', 'jennie', 'kevin'];
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]); // To store the original data

  const fetchData = async () => {
    try {
      const allData = await Promise.all(
        tables.map(async (tableName) => {
          const response = await axios.get(`${API_URL}?table=${tableName}`);
          if (Array.isArray(response.data)) {
            return response.data;
          } else {
            throw new Error('Data is not in expected format');
          }
        })
      );
      const combinedData = allData.flat();
      setData(combinedData);
      setOriginalData(combinedData); // Store the original data
    } catch (error) {
      console.error('Failed to fetch data:', error);
      // Handle error
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const sumColumn = (columnName) => {
    if (data.length === 0) {
      return 0; // Return default value or handle empty state
    }
    return data.reduce((total, rowData) => total + (Number(rowData[columnName]) || 0), 0);
  };

  const filterData = (e) => {
      e.preventDefault();
      if (!startDate || !endDate) return;
    
      const filteredData = originalData.filter((row) => {
        const dateDelivered = new Date(row.dd);
        return dateDelivered >= new Date(startDate) && dateDelivered <= new Date(endDate);
      });
      setData(filteredData);
    };

  const resetData = (e) => {
    e.preventDefault();
    setStartDate('');
    setEndDate('');
    setData(originalData); // Reset to original data
  };
  return (
    <div className='w-full h-auto flex justify-center items-center flex-wrap flex-col bg-white backdrop-filter backdrop-blur-sm bg-opacity-30 p-6 rounded-md mt-8'>
      <div className='w-full h-auto bg-white flex justify-start items-center border-red-700 border-l-4 py-2 px-4 rounded-sm'>
        <h1 className='ml-2 text-sky-800 text-xl font-bold'>Consolidated Report</h1>
      </div>
      <div className='w-full h-auto flex md:justify-between justify-center flex-wrap items-start mt-6'>
        <div className='h-auto md:w-[32%] w-full bg-white border-blue-700 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 border-b-4 py-4 px-3 rounded-md'>
          <h1 className='text-lg text-gray-500 text-left'>Total No. of Records Delivered</h1>
          <h1 className='text-3xl font-bold text-gray-800 mt-3 text-left'><NumberAnimated n={sumColumn('recordD')} /></h1>
        </div>
        <div className='h-auto md:w-[32%] w-full bg-white bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 border-yellow-500 border-b-4 py-4 px-3 md:mt-0 mt-6 rounded-md'>
          <h1 className='text-lg text-gray-500 text-left'>Total No. of unacceptable emails</h1>
          <h1 className='text-3xl font-bold text-gray-800 mt-3 text-left'><NumberAnimated n={sumColumn('uEmail')} /></h1>
        </div>
        <div className='h-auto md:w-[32%] w-full bg-white bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 border-green-500 border-b-4 py-4 px-3 md:mt-0 mt-6 rounded-md'>
          <h1 className='text-lg text-gray-500 text-left'>Final No. of Records</h1>
          <h1 className='text-3xl font-bold text-gray-800 mt-3 text-left'><NumberAnimated n={sumColumn('fr')} /></h1>
        </div>
      </div>
      <div className="w-full h-auto flex justify-between items-center md:flex-row flex-col bg-white bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 p-4 mt-6 rounded-t-sm">
        <div className='md:w-[65%] w-full h-auto'>
          <form className='w-full h-auto flex md:justify-between justify-center items-center flex-wrap'>
            <input className='py-2 px-4 rounded-sm' value={startDate} onChange={(e) => setStartDate(e.target.value)} type="date" name='do' id='do' />
            <input className='py-2 px-4  md:mt-0 mt-4 rounded-sm' value={endDate} onChange={(e) => setEndDate(e.target.value)} type="date" name='do' id='do' />
            <button onClick={filterData} className='py-2 px-4 md:mt-0 mt-4 bg-sky-600 hover:bg-sky-800 cursor-pointer text-white rounded-sm'>Filter</button>
            <button onClick={resetData} className='py-2 px-4 md:ml-0 ml-2 md:mt-0 mt-4 bg-red-600 hover:bg-red-800 cursor-pointer text-white rounded-sm'>Reset</button>
          </form>
        </div>
      </div>
      <div className="flex w-full h-auto flex-col overflow-x-auto bg-white bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70">
        <div className="w-full h-auto">
          <div className="inline-block min-w-full">
            <div className="overflow-x-auto">
              <table className="min-w-full text-start text-sm font-light text-surface  dark:text-white">
                <thead className="border-b border-neutral-200 bg-neutral-50 font-medium dark:border-white/10 dark:text-neutral-800">
                  <tr>
                    <th scope="col" className="whitespace-nowrap text-start px-6 py-4">File Name</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">Samples Provided</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">Project Type</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">Date Ordered</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">ETA</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">Billed Yet</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">Date Delivered</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">No. of Records Delivered</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">No. of unacceptable emails</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">Final No. of Records</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((userData, index) => (
                      <tr key={index} className="border-b border-neutral-200 dark:border-white/10">
                        <td className="whitespace-nowrap px-6 py-4">{userData.fileName}</td>
                        <td className="whitespace-nowrap px-6 py-4">{userData.sample}</td>
                        <td className="whitespace-nowrap px-6 py-4">{userData.ptype}</td>
                        <td className="whitespace-nowrap px-6 py-4">{userData.do}</td>
                        <td className="whitespace-nowrap px-6 py-4">{userData.eta}</td>
                        <td className="whitespace-nowrap px-6 py-4">{userData.bill}</td>
                        <td className="whitespace-nowrap px-6 py-4">{userData.dd}</td>
                        <td className="whitespace-nowrap px-6 py-4">{userData.recordD}</td>
                        <td className="whitespace-nowrap px-6 py-4">{userData.uEmail}</td>
                        <td className="whitespace-nowrap px-6 py-4">{userData.fr}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                        <td colSpan={10} className="whitespace-nowrap px-6 py-4">No Data Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Consolidated;